import type { StaticTranslationString } from '@/types/types';

export const fieldIsRequiredText: StaticTranslationString = {
  en: 'This field is required.',
  de: 'Dieses Feld ist erforderlich.',
  fr: 'Ce champ est obligatoire.',
};

export const fieldIsNotValidText: StaticTranslationString = {
  en: 'The format is not valid.',
  de: 'Das Format ist ungültig.',
  fr: 'Le format n’est pas valide.',
};

export const invalidEmailText: StaticTranslationString = {
  en: 'Please enter a valid email address.',
  de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  fr: 'Veuillez entrer une adresse e-mail valide.',
};

export const invalidNumberText: StaticTranslationString = {
  en: 'Please enter a valid number.',
  de: 'Bitte geben Sie eine gültige Nummer ein.',
  fr: 'Veuillez entrer un nombre valide.',
};

export const invalidDateText: StaticTranslationString = {
  en: 'Please enter a valid date.',
  de: 'Bitte geben Sie ein gültiges Datum ein.',
  fr: 'Veuillez entrer une date valide.',
};

export const invalidSelectionText: StaticTranslationString = {
  en: 'Invalid selection.',
  de: 'Ungültige Auswahl.',
  fr: 'Sélection invalide.',
};

export const loginWithCeviDatabaseText: StaticTranslationString = {
  en: 'Login with Cevi.DB',
  de: 'Anmelden mit Cevi.DB',
  fr: 'Se connecter avec Cevi.DB',
};

export const loggedInAsText: StaticTranslationString = {
  en: 'Logged in as',
  de: 'Angemeldet als',
  fr: 'Connecté en tant que',
};

export const changeUserText: StaticTranslationString = {
  en: 'Change User',
  de: 'Benutzer wechseln',
  fr: 'Changer d’utilisateur',
};

export const requiredCeviDatabaseLoginText: StaticTranslationString = {
  en: 'You must be logged in with Cevi.DB to submit this form.',
  de: 'Sie müssen mit Cevi.DB angemeldet sein, um dieses Formular abzusenden.',
  fr: 'Vous devez être connecté avec Cevi.DB pour soumettre ce formulaire.',
};

export const skipLoginText: StaticTranslationString = {
  en: 'Skip Login',
  de: 'Anmeldung überspringen',
  fr: 'Passer la connexion',
};

export const skippedText: StaticTranslationString = {
  en: 'Skipped',
  de: 'Übersprungen',
  fr: 'Ignoré',
};

export const spotsLeftText: StaticTranslationString = {
  en: 'spots left',
  de: 'Plätze übrig',
  fr: 'places restantes',
};

export const spotLeftText: StaticTranslationString = {
  en: 'spot left',
  de: 'Platz übrig',
  fr: 'place restante',
};
